<dx-data-grid
  id="tractorHistoryMessagesGrid"
  [dataSource]="ds"
  [width]="width"
  [height]="height"
  [showRowLines]="true"
  [grouping]="{ contextMenuEnabled: true }"
  [allowColumnReordering]="true"
  [allowColumnResizing]="true"
  [rowAlternationEnabled]="false"
  [hoverStateEnabled]="true"
  [columnHidingEnabled]="false"
  [columnAutoWidth]="true"
  (onRowClick)="onRowClick($event)"
  [libGridTitle]="{ text: 'Messages' }"
  [showBorders]="false"
>
  <dxi-column caption="Date">
    <dxi-column
      caption="Serveur"
      dataType="date"
      format="shortDateShortTime"
      dataField="server_time"
    >
    </dxi-column>

    <dxi-column
      caption="Traceur"
      dataType="date"
      format="shortDateShortTime"
      dataField="tracker_time"
    >
    </dxi-column>
  </dxi-column>

  <dxi-column caption="GPS">
    <dxi-column caption="IMEI" dataField="imei"> </dxi-column>
    <dxi-column caption="Latitude" format="#0.######" dataField="lat">
    </dxi-column>
    <dxi-column caption="Longitude" format="#0.######" dataField="lng">
    </dxi-column>
    <dxi-column caption="Altitude" dataField="altitude"> </dxi-column>
    <dxi-column caption="Speed" dataField="speed"> </dxi-column>
    <dxi-column caption="Angle" dataField="angle"> </dxi-column>
    <dxi-column caption="Satellites" dataField="satellites"> </dxi-column>
    <dxi-column caption="HDOP" dataField="hdop"> </dxi-column>
  </dxi-column>
  <dxi-column caption="GSM">
    <dxi-column caption="MCC" dataField="mcc"> </dxi-column>
    <dxi-column caption="LAC" dataField="lac"> </dxi-column>
    <dxi-column caption="Cell ID" dataField="cell_id"> </dxi-column>
    <dxi-column caption="MNC" dataField="mnc"> </dxi-column>
    <dxi-column caption="TA" dataField="ta"> </dxi-column>
    <dxi-column caption="Level" dataField="gsm_lvl"> </dxi-column>
  </dxi-column>

  <dxi-column caption="Inputs" cellTemplate="inTemplate" dataField="in">
    <div *dxTemplate="let data of 'inTemplate'">
      <div class="flex items-center">
        <div
          class="packet-in"
          [ngClass]="{ active: data.data.isINActive(i + 1) }"
          *ngFor="let item of [].constructor(16); let i = index"
        >
          {{ i + 1 }}
        </div>
      </div>
    </div>
  </dxi-column>

  <dxi-column caption="ADC">
    <dxi-column caption="ADC2" format="#0.###" dataField="adc2"> </dxi-column>
    <dxi-column caption="ADC3" format="#0.###" dataField="adc3"> </dxi-column>
    <dxi-column caption="ADC4" format="#0.###" dataField="adc4"> </dxi-column>
    <dxi-column caption="ADC5" format="#0.###" dataField="adc5"> </dxi-column>
    <dxi-column caption="ADC6" format="#0.###" dataField="adc6"> </dxi-column>
  </dxi-column>

  <dxi-column caption="Thermo-hygromètre">
    <dxi-column caption="température" dataField="rs485_temperature">
    </dxi-column>
    <dxi-column caption="humidité" dataField="rs485_humidity"> </dxi-column>
  </dxi-column>

  <dxi-column caption="RFID" dataField="rfid"> </dxi-column>

  <dxi-column caption="Carburant">
    <dxi-column
      caption="Temperature"
      format="#0.###"
      dataField="fuel_temperature"
    >
    </dxi-column>
    <dxi-column caption="Total (L)" dataField="fuel_hr_total_consumption">
    </dxi-column>
    <dxi-column
      caption="L/h"
      format="#0.###"
      dataField="fuel_hourly_consumption_rate"
    >
    </dxi-column>
    <dxi-column caption="Heures Moteur (s)" dataField="engine_working_time">
    </dxi-column>
    <dxi-column caption="Mode" dataField="engine_operation_mode"> </dxi-column>
  </dxi-column>

  <dxo-selection mode="single"></dxo-selection>

  <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

  <dxo-group-panel [visible]="false"></dxo-group-panel>

  <dxo-export
    [enabled]="true"
    fileName="liste-messages"
    [allowExportSelectedData]="true"
  ></dxo-export>

  <dxo-sorting mode="multiple"></dxo-sorting>

  <dxo-paging [pageSize]="25"></dxo-paging>

  <dxo-pager
    [showPageSizeSelector]="true"
    [allowedPageSizes]="[25, 50, 100]"
    [showInfo]="true"
  >
  </dxo-pager>

  <dxo-filter-row [visible]="true"></dxo-filter-row>

  <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>

  <dxo-header-filter [visible]="true"></dxo-header-filter>
</dx-data-grid>
